import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6aaad120"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]
const _hoisted_2 = {
  key: 2,
  class: "absolute top-0 right-0 bottom-0 grid grid-cols-12 grid-rows-6"
}
const _hoisted_3 = {
  key: 0,
  class: "col-start-2 row-start-4 flex items-end"
}
const _hoisted_4 = { class: "w-full h-11 flex justify-center items-center rounded text-white text-base horizontal-gradient" }
const _hoisted_5 = { class: "col-start-6 col-span-6 row-span-full flex items-center" }
const _hoisted_6 = {
  key: 3,
  class: "h-full pl-36 pr-96 flex flex-col justify-center gap-8 text-primary"
}
const _hoisted_7 = { class: "text-5xl font-bold" }
const _hoisted_8 = ["innerHTML"]

import { reactive } from 'vue';
import { QCarouselProps } from 'quasar';
import { RegionDto } from 'src/api/types';
import tmpl from 'src/utils/tmpl';
import SvVideoPlayer from 'src/components/SvVideoPlayer.vue';

export interface SvCarouselProps extends QCarouselProps {
  regions: RegionDto[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SvCarousel',
  props: {
    regions: {},
    fullscreen: { type: Boolean },
    noRouteFullscreenExit: { type: Boolean },
    modelValue: {},
    keepAlive: { type: Boolean },
    keepAliveInclude: {},
    keepAliveExclude: {},
    keepAliveMax: {},
    animated: { type: Boolean },
    infinite: { type: Boolean },
    swipeable: { type: Boolean },
    vertical: { type: Boolean },
    transitionPrev: {},
    transitionNext: {},
    transitionDuration: {},
    dark: { type: Boolean },
    height: {},
    padding: { type: Boolean },
    controlColor: {},
    controlTextColor: {},
    controlType: {},
    autoplay: { type: [Number, Boolean] },
    arrows: { type: Boolean },
    prevIcon: {},
    nextIcon: {},
    navigation: { type: Boolean },
    navigationPosition: {},
    navigationIcon: {},
    navigationActiveIcon: {},
    thumbnails: { type: Boolean },
    onFullscreen: { type: Function },
    "onUpdate:modelValue": { type: Function },
    onBeforeTransition: { type: Function },
    onTransition: { type: Function }
  },
  setup(__props: any) {

const props = __props;

const state = reactive({
  value: 0,
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_carousel_slide = _resolveComponent("q-carousel-slide")!
  const _component_q_carousel = _resolveComponent("q-carousel")!

  return (_openBlock(), _createBlock(_component_q_carousel, _mergeProps(props, {
    modelValue: state.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.value) = $event))
  }), {
    "navigation-icon": _withCtx((navigation) => [
      _renderSlot(_ctx.$slots, "navigation-icon", _normalizeProps(_guardReactiveProps(navigation)))
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.regions, (region, i) => {
        return (_openBlock(), _createBlock(_component_q_carousel_slide, {
          key: region.id,
          name: i,
          "img-src": region.image
        }, {
          default: _withCtx(() => [
            (region.url && /^http/.test(region.url))
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "absolute left-0 top-0 right-0 bottom-0",
                  target: "_blank",
                  href: _unref(tmpl)(region.url, region)
                }, null, 8, _hoisted_1))
              : _createCommentVNode("", true),
            (region.url && !/^http/.test(region.url))
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  class: "absolute left-0 top-0 right-0 bottom-0",
                  to: _unref(tmpl)(region.url, region)
                }, null, 8, ["to"]))
              : _createCommentVNode("", true),
            (/\.mp4$|\.mp4?/.test(region.content ?? ''))
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (region.url)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_component_q_btn, {
                          class: "w-40 h-11",
                          "no-caps": "",
                          square: "",
                          padding: "0",
                          to: _unref(tmpl)(region.url, region)
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('Index.more')), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(SvVideoPlayer, {
                      src: region.content,
                      style: {"width":"calc(50vw)","height":"calc(50vw / 16 * 9)","border-radius":"10px","overflow":"hidden"}
                    }, null, 8, ["src"])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(region.content), 1),
                  _createElementVNode("div", {
                    innerHTML: region.summary?.replace(/[\r\n]/g, '<br/>')
                  }, null, 8, _hoisted_8)
                ]))
          ]),
          _: 2
        }, 1032, ["name", "img-src"]))
      }), 128))
    ]),
    _: 3
  }, 16, ["modelValue"]))
}
}

})